import { Dialog, DialogContent } from '@mui/material'
import Loader from './Loader'

const LoaderModal = ({ open }) => {
  return (
    <Dialog open={open}>
        <DialogContent>
            <Loader/>
        </DialogContent>
    </Dialog>
  )
}

export default LoaderModal
